module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/stage-1-526c34ccf07fb928db08c5dec786644b.png";